export default __webpack_public_path__ + "images/84b1a48c4c4bc17bdf4adf0218cb4299.png";